// Styled components theme
const theme = {
  color: {
    default: 'grey',
    primary: 'blue',
    danger: 'tomato',
    dangerLight: '#fcdbd9',
    success: 'green',
    successLight: '#cfefdf',
    link: 'blue',
  },
  fontSize: {
    small: '14px',
    normal: '16px',
  },
};

export default theme;
